/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, useState } from "react";
import Theme from "./theme";

const MessageBox = (props) => {
  const { background, close } = props;
  const [visible, setVisible] = useState(0);

  setTimeout(() => {
    setVisible(true);
  }, 500);

  return (
    <Theme background={background}>
      {visible && (
        <Fragment>
          <i onClick={close} className="fas fa-times close"></i>

          <div
            className="wrapper"
            onClick={() =>
              window.open(
                "https://www.youtube.com/watch?v=iXGtx-hroKE",
                "_blank"
              )
            }
          >
            <h5 className="title is-hidden-mobile">
              Did you see this beautiful video about remote working?
            </h5>

            <h5 className="title is-5 is-hidden-tablet">
              Did you see this beautiful video about remote working?
            </h5>

            <br />

            <p className="subtitle">Click here to watch it</p>
          </div>
        </Fragment>
      )}
    </Theme>
  );
};

export default MessageBox;
